// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6d58b3e1","148":"b9cec259","237":"c53b7643","243":"231a007f","393":"5203946a","469":"d1bb8bd6","540":"e9edc9c1","556":"b9f20e05","718":"06ffb91d","722":"b6d642ce","890":"4a0b87ab","937":"0ef7e58b"}[chunkId] + ".chunk.js";
};